export default __webpack_public_path__ + "static/media/crypto.e15cbdbe.png";